import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { WMTM_ASSETS } from "./whatMattersToMeCardData";
import "./whatMattersToMeCard.scss";
import { useHistory } from "react-router-dom";
import { WatchlistApi } from "../../../../../../core/api/watchlistApi";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import AreaLoader from "../../../../../../layout/components/loading/areaLoader";
import starIcon from "../../../../../../assets/img/star.svg";
import { SessionStorage } from "../../../../../../core/helpers/localStorage/sessionStorage";
import { SessionVariables } from "../../../../../../core/constants/SessionVariables";
import NoData from "../../NoData";
import IMG_FOOTER_ARROW from "../../../../../../assets/img/arrowSvg.svg";
import RenderSvg from "../../../../../../layout/components/icons/RenderSvg";
import { CaretDownFilled } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
function kpiVariantFromRatingCounts(item) {
    const n = (v) => {
        const x = Number(v);
        if (!Number.isFinite(x) || x < 0)
            return 0;
        return x;
    };
    const red = n(item.red);
    const amber = n(item.amber);
    const green = n(item.green);
    const darkGreen = n(item.darkGreen);
    const grey = n(item.grey);
    const unrateable = n(item.unrateable);
    const maxVisible = Math.max(red, amber, green, darkGreen, unrateable);
    if (maxVisible === 0) {
        return "glass";
    }
    const maxAll = Math.max(red, amber, green, darkGreen, grey, unrateable);
    if (darkGreen === maxAll) {
        return "tint-green";
    }
    if (green === maxAll) {
        return "tint-green-light";
    }
    if (red === maxAll) {
        return "tint-red";
    }
    if (amber === maxAll) {
        return "tint-orange";
    }
    if (grey === maxAll) {
        return "glass-highlight";
    }
    if (unrateable === maxAll) {
        return "glass-highlight";
    }
    return "glass";
}
function KpiTile({ tile }) {
    const { nodeId, title, titleTone, titleFont, iconSrc, iconW, iconH, variant, metrics, metricsGap, overflowClip, onClick, } = tile;
    return (React.createElement("div", { className: "what-matters-to-me-card__kpi-row-cell" },
        React.createElement("div", { className: classNames("what-matters-to-me-card__kpi-tile", `what-matters-to-me-card__kpi-tile--${variant}`, overflowClip && "what-matters-to-me-card__kpi-tile--overflow-clip", variant === "glass-highlight" &&
                "what-matters-to-me-card__kpi-tile--highlight-layout"), "data-node-id": nodeId, onClick: onClick, style: { cursor: "pointer" } },
            variant === "glass-orange-overlay" && (React.createElement("div", { className: "what-matters-to-me-card__kpi-tile-orange-overlay", "data-node-id": "1:5032", "aria-hidden": true })),
            variant === "glass-img-overlay" && (React.createElement("div", { className: "what-matters-to-me-card__kpi-tile-img-overlay", "data-node-id": "1:5061", "aria-hidden": true },
                React.createElement("img", { alt: "", className: "what-matters-to-me-card__kpi-tile-img-gradient", src: WMTM_ASSETS.imgGradient }))),
            React.createElement("div", { className: "what-matters-to-me-card__kpi-tile-section what-matters-to-me-card__kpi-tile-section--title" },
                React.createElement("div", { className: classNames("what-matters-to-me-card__kpi-heading", titleTone === "white" &&
                        "what-matters-to-me-card__kpi-heading--white", titleTone === "muted-white" &&
                        "what-matters-to-me-card__kpi-heading--muted-white", titleFont === "montserrat" &&
                        "what-matters-to-me-card__kpi-heading--montserrat", titleFont === "inter" &&
                        "what-matters-to-me-card__kpi-heading--inter") },
                    React.createElement("div", { className: classNames("what-matters-to-me-card__kpi-icon-wrap", `icon-gradient-${variant}`), style: {
                            width: 18,
                            height: 18,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        } },
                        React.createElement(RenderSvg, { icon: "FileIcon", className: "wmtm-file-icon" })),
                    React.createElement("div", { className: "what-matters-to-me-card__kpi-title-text" },
                        React.createElement("p", { className: "what-matters-to-me-card__kpi-title-p" }, title)))),
            React.createElement("div", { className: "what-matters-to-me-card__kpi-tile-section what-matters-to-me-card__kpi-tile-section--metrics" },
                React.createElement("div", { className: classNames("what-matters-to-me-card__kpi-metrics", metricsGap === 10 &&
                        "what-matters-to-me-card__kpi-metrics--gap-10", metricsGap === 12 &&
                        "what-matters-to-me-card__kpi-metrics--gap-12") }, metrics.map((m, i) => (React.createElement("div", { key: `${nodeId}-m-${i}`, className: "what-matters-to-me-card__kpi-metric" },
                    React.createElement("div", { className: "what-matters-to-me-card__kpi-dot", style: { backgroundColor: m.dotColor } }),
                    React.createElement("div", { className: "what-matters-to-me-card__kpi-metric-label-wrap" },
                        React.createElement("p", { className: classNames("what-matters-to-me-card__kpi-metric-label", titleFont === "inter" &&
                                "what-matters-to-me-card__kpi-metric-label--inter") }, m.label))))))))));
}
const WhatMattersToMeCard = () => {
    const [items, setItems] = useState(undefined);
    const [activeId, setActiveId] = useState(null);
    // SORT STATE
    const [selectedSort, setSelectedSort] = useState("A-Z");
    // Convert dropdown option into API params
    const sortConfig = useMemo(() => {
        switch (selectedSort) {
            case "A-Z":
                return { sortColumn: "entityName", sortOrder: "asc" };
            case "Z-A":
                return { sortColumn: "entityName", sortOrder: "desc" };
            default:
                return { sortColumn: "entityName", sortOrder: "asc" };
        }
    }, [selectedSort]);
    const history = useHistory();
    const { promiseInProgress } = usePromiseTracker({
        area: "watchlist-area",
    });
    const hasData = items && items.length > 0;
    const isEmpty = !promiseInProgress && items && items.length === 0;
    const menu = (React.createElement(Menu, { onClick: (e) => setSelectedSort(e.key), className: "custom-dropdown-menu" },
        React.createElement(Menu.Item, { key: "A-Z" }, "A-Z"),
        React.createElement(Menu.Item, { key: "Z-A" }, "Z-A")));
    const sortedItems = useMemo(() => {
        if (!items)
            return [];
        const list = [...items];
        if (selectedSort === "A-Z") {
            list.sort((a, b) => (a.watchListName || "").localeCompare(b.watchListName || ""));
        }
        if (selectedSort === "Z-A") {
            list.sort((a, b) => (b.watchListName || "").localeCompare(a.watchListName || ""));
        }
        return list;
    }, [items, selectedSort]);
    useEffect(() => {
        trackPromise(WatchlistApi.getUserWatchList({ area: "watchlist-area" })
            .then((watchlists) => {
            if (!watchlists || !Array.isArray(watchlists)) {
                setItems([]);
                return;
            }
            const results = watchlists.map((watch) => {
                var _a, _b, _c, _d, _e, _f, _g;
                return ({
                    id: watch === null || watch === void 0 ? void 0 : watch.id,
                    watchListName: watch === null || watch === void 0 ? void 0 : watch.watchListName,
                    isDefault: (_a = watch === null || watch === void 0 ? void 0 : watch.isDefault) !== null && _a !== void 0 ? _a : !(watch === null || watch === void 0 ? void 0 : watch.canBeDeleted),
                    red: (_b = watch === null || watch === void 0 ? void 0 : watch.red) !== null && _b !== void 0 ? _b : 0,
                    amber: (_c = watch === null || watch === void 0 ? void 0 : watch.amber) !== null && _c !== void 0 ? _c : 0,
                    green: (_d = watch === null || watch === void 0 ? void 0 : watch.green) !== null && _d !== void 0 ? _d : 0,
                    darkGreen: (_e = watch === null || watch === void 0 ? void 0 : watch.darkGreen) !== null && _e !== void 0 ? _e : 0,
                    grey: (_f = watch === null || watch === void 0 ? void 0 : watch.grey) !== null && _f !== void 0 ? _f : 0,
                    unrateable: (_g = watch === null || watch === void 0 ? void 0 : watch.unrateable) !== null && _g !== void 0 ? _g : 0,
                });
            });
            setItems(results);
        })
            .catch(() => setItems([])), "watchlist-area");
        const storedItem = SessionStorage.getKey(SessionVariables.WATCHLIST_ACTIVE_TAB);
        if (storedItem === null || storedItem === void 0 ? void 0 : storedItem.id) {
            setActiveId(storedItem.id);
        }
    }, []);
    const handleClick = (item) => {
        SessionStorage.setKey(SessionVariables.WATCHLIST_ACTIVE_TAB, item);
        setActiveId(item.id);
        history.push("/vertical/watchlist");
    };
    const kpiRows = useMemo(() => {
        if (!items || items.length === 0)
            return [];
        const mapToMetrics = (item) => [
            { dotColor: "#15803D", label: String(item.darkGreen) },
            { dotColor: "#4ade80", label: String(item.green) },
            { dotColor: "#fb923c", label: String(item.amber) },
            { dotColor: "#dc2626", label: String(item.red) },
            { dotColor: "#c3c3c3", label: String(item.unrateable) },
        ];
        const tiles = sortedItems.map((item) => ({
            nodeId: `watchlist-${item.id}`,
            title: item.watchListName,
            titleTone: "white",
            titleFont: "montserrat",
            iconSrc: item.isDefault ? WMTM_ASSETS.icons.a : WMTM_ASSETS.icons.b,
            iconW: 13.5,
            iconH: 13.5,
            variant: kpiVariantFromRatingCounts({
                red: item.red,
                amber: item.amber,
                green: item.green,
                darkGreen: item.darkGreen,
                grey: item.grey,
                unrateable: item.unrateable,
            }),
            metricsGap: 12,
            metrics: mapToMetrics(item),
            overflowClip: false,
            onClick: () => handleClick(item),
        }));
        // break into rows of 3 (same as Figma layout)
        const rows = [];
        for (let i = 0; i < tiles.length; i += 3) {
            rows.push(tiles.slice(i, i + 3));
        }
        return rows;
    }, [sortedItems]);
    return (React.createElement("div", { className: "what-matters-to-me-card", "data-node-id": "1:4989" },
        promiseInProgress && (React.createElement("div", { style: {
                position: "absolute",
                inset: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
            } },
            React.createElement(AreaLoader, { area: "watchlist-area", isLandingPage: true }))),
        React.createElement("div", { className: "what-matters-to-me-card__header", "data-node-id": "1:4990" },
            React.createElement("div", { className: "what-matters-to-me-card__title-block", "data-node-id": "1:4991" },
                React.createElement("p", { className: "what-matters-to-me-card__title" }, "What Matters to Me")),
            React.createElement("div", { className: "what-matters-to-me-card__subtitle-block", "data-node-id": "1:4992" },
                React.createElement("p", { className: "what-matters-to-me-card__subtitle" }, items ? `${items.length} Watchlists` : ""))),
        React.createElement("div", { className: "what-matters-to-me-card__toolbar-outer", "data-node-id": "1:4993" },
            React.createElement("div", { className: "what-matters-to-me-card__toolbar-overlay", "aria-hidden": true }),
            React.createElement("div", { className: "what-matters-to-me-card__toolbar-bar", "data-node-id": "1:4994" },
                React.createElement("div", { className: "still-matters-detail__sort-bar" },
                    React.createElement(Dropdown, { overlay: menu, trigger: ["click"] },
                        React.createElement("span", { className: "sort-dropdown" },
                            "Sort by: ",
                            selectedSort,
                            " ",
                            React.createElement(CaretDownFilled, null))))),
            React.createElement("div", { className: "what-matters-to-me-card__toolbar-inset-shadow", "aria-hidden": true })),
        !promiseInProgress && hasData && (React.createElement("div", { className: "what-matters-to-me-card__kpi-grid", "data-node-id": "1:5001" }, kpiRows.map((row, ri) => (React.createElement("div", { key: `wmtm-row-${ri}`, className: "what-matters-to-me-card__kpi-row" }, row.map((tile) => (React.createElement(KpiTile, { key: tile.nodeId, tile: tile })))))))),
        isEmpty && (React.createElement("div", { className: "what-matters-to-me-card__empty" },
            React.createElement(NoData, { message: "No Watchlist yet!", detail: "Create a watchlist to track the metrics that matters to you.", logo: starIcon }))),
        React.createElement("div", { className: "what-matters-to-me-card__footer-margin", "data-node-id": "1:5428" },
            React.createElement("div", { className: "what-matters-to-me-card__footer-inner", "data-node-id": "1:5429" },
                React.createElement("button", { type: "button", onClick: () => history.push("/vertical/watchlist"), className: "what-matters-to-me-card__footer-cta", "data-node-id": "1:5430" },
                    React.createElement("span", { className: "what-matters-to-me-card__footer-cta-text", "data-node-id": "1:5431" }, "View All"),
                    React.createElement("span", { className: "what-matters-to-me-card__footer-cta-icon", "data-node-id": "1:5432" },
                        React.createElement("img", { alt: "", src: IMG_FOOTER_ARROW, className: "what-matters-to-me-card__footer-cta-img" })))))));
};
export default WhatMattersToMeCard;
